// extracted by mini-css-extract-plugin
export default {"container":"patronage_container__hdk4V","header":"patronage_header__svtrM","logos":"patronage_logos__GS0-I","logo":"patronage_logo__NA-JD"};